import {isIncludesTerm} from '.';
import {IGoogleSite} from '../../../../../models/resources/google-sites';

export const filterGoogleSites = (clonedList: IGoogleSite[], searchTerm: string) =>
  clonedList.filter((item) => {
    const hasIncludesTermInName = isIncludesTerm(searchTerm, item?.name);
    return hasIncludesTermInName;
  });
